
@if (apiService.readyAndAuthenticated() === false) {
    <div class="login" [ngClass]="{ 'custom-styles': true }">
        <kendo-card width="512px">
            <kendo-card-header>Sercom Auth</kendo-card-header>
            <kendo-card-body>
                <img src="../../../assets/skov-logo.svg" width="480px" alt="logo" />
                <div class="login-btn">
                    <auth-badge></auth-badge>
                </div>
            </kendo-card-body>
        </kendo-card>
    </div>    

} @else {
    <ng-container>
        <div class="badge"><auth-badge></auth-badge></div>
        <router-outlet></router-outlet>
    </ng-container>
}
